'use client';

import React, { cloneElement } from 'react';
import useInspectorMode from '@src/hooks/useInspectorMode';

import { InspectorWrapperPropTypes } from './InspectorWrapper.types';

const InspectorWrapper: React.FC<InspectorWrapperPropTypes> = ({ entryId, fieldId, children }) => {
  const inspectorProps = useInspectorMode({ entryId });

  // Clone the child element and inject inspectorProps
  return cloneElement(children, {
    // React 19 types element props as `unknown`; this child is a known element.
    ...(children.props as Record<string, unknown>),
    ...inspectorProps({ fieldId }),
  });
};

export default InspectorWrapper;
